import { ICreateInterLinkDTO, IPagePath } from '@/models/linkingTool.model';
import { LinkingFormFields, TCreateLinkingTemplateFormValues } from '../helpers';

class CreateInterLinkDTO implements ICreateInterLinkDTO {
  pagePath: string;

  channelId: number;

  links?: IPagePath[];

  constructor(values: TCreateLinkingTemplateFormValues & { channelId: number }) {
    this.pagePath = decodeURIComponent(decodeURIComponent(values[LinkingFormFields.PAGE_PATH]));

    this.links = values[LinkingFormFields.LINKS] ?? null;

    this.channelId = values.channelId;
  }
}

export default CreateInterLinkDTO;
